import { SignInOptions, SignOutParams } from 'next-auth/react';
import { useCallback } from 'react';
import { useExperiments } from 'src/services/experiments/ContextProviders/ExperimentProvider';
import { handleSessionStart } from './utils/handleSessionStart';
import { handleSessionTermination } from './utils/handleSessionTermination';
import { useZillowSession } from './useZillowSession';

export type SessionTerminationConfig = SignOutParams & {
    errorMessage?: string;
};

export const useSessionManagement = () => {
    const { experiments } = useExperiments();
    const sessionHookResult = useZillowSession();
    const startSession = useCallback(
        (
            justification: string,
            signInOptions: SignInOptions = {},
            authorizationParams: Record<string, string> = {}
        ) => {
            handleSessionStart(justification, experiments, signInOptions, authorizationParams);
        },
        [experiments]
    );
    const endSession = useCallback(
        (justification: string, { errorMessage, ...config }: SessionTerminationConfig = {}) => {
            handleSessionTermination(justification, errorMessage, config);
        },
        []
    );

    return {
        startSession,
        endSession,
        ...sessionHookResult,
    };
};
